const requests_routes = [
    {
        path: 'dashboard',
        name: 'mm-dashboard',
        component: () => import('@/views/requests/overview/DashboardLibrary.vue'),
        meta: {
            require_auth: true,
            require_role: [],
            title: 'Dashboard',
            icon: 'GridIcon',
            slug: 'home/dashboard',
            searchable: true,
            parent: 'home'
        }
    },
    {
        path: 'requests/',
        component: () =>
            import(
                /* webpackChunkName: "requests" */
                '@/components/generic/VxAppModuleRoot.vue'
            ),
        props: {
            onlyCache: ['requests-library', 'service-tasks-library']
        },
        children: [
            {
                path: '',
                name: 'mm-requests',
                component: () =>
                    import(
                        /* webpackChunkName: "requests" */
                        '@/views/requests/requests/RequestsLibrary.vue'
                    ),
                meta: {
                    require_auth: true,
                    require_role: ['ADMIN_OFFICER', 'ADMINISTRATOR', 'SuperUser'],
                    title: 'Requests',
                    icon: 'ListIcon',
                    slug: 'requests/activeRequests',
                    searchable: true,
                    parent: 'requests'
                }
            },

            {
                path: ':activeOrCompleted/:requestId/:action?/:serviceTaskId?',
                name: 'request-details',
                props: true,
                meta: {
                    require_auth: true,
                    require_role: ['ADMIN_OFFICER', 'ADMINISTRATOR', 'SuperUser'],
                    // require_role: requires_role,
                    // title: `Request Details`,
                    // icon: 'MessageSquareIcon',
                    // slug: '/requests/details',
                    searchable: false,
                    parent: 'requests',
                    param_restrictions: {
                        action: ['approve-service-task', 'view']
                    }
                },
                component: () =>
                    import(
                        /* webpackChunkName: "requests" */
                        '@/views/requests/requests/RequestDetails.vue'
                    )
            },
            {
                path: 'new',
                name: 'request-new',
                meta: {
                    require_auth: true,
                    require_role: ['ADMIN_OFFICER', 'ADMINISTRATOR', 'SuperUser'],
                    title: 'New Request',
                    icon: 'MessageSquareIcon',
                    slug: 'requests/active/new',
                    searchable: true,
                    parent: 'requests'
                },
                component: () =>
                    import(
                        /* webpackChunkName: "requests" */
                        '@/views/requests/requests/RequestDetails.vue'
                    )
            }
        ]
    },
    {
        path: 'tasks',
        name: 'mm-tasks',
        component: () => import('@/views/requests/serviceTasks/ServiceTasksLibrary.vue'),
        meta: {
            require_auth: true,
            require_role: ['ADMIN_OFFICER', 'ADMINISTRATOR', 'SuperUser'],
            title: 'Tasks',
            icon: 'LayersIcon',
            slug: 'requests/activeTasks',
            searchable: true,
            parent: 'requests'
        }
    },
    {
        path: 'export',
        name: 'mm-export',
        component: () => import('@/views/requests/reports/ExportLibrary.vue'),
        meta: {
            require_auth: true,
            require_role: ['ADMINISTRATOR', 'SuperUser'],
            title: 'Export',
            icon: 'DollarSignIcon',
            slug: 'requests/export',
            searchable: true,
            parent: 'requests'
        }
    }
    // {
    //     path: 'awaiting-claim',
    //     name: 'mm-awaiting-claim',
    //     component: () => import('@/views/requests/reports/AwaitingClaimsLibrary.vue'),
    //     meta: {
    //         require_auth: true,
    //         title: 'Awaiting Claim',
    //         icon: 'DollarSignIcon',
    //         slug: 'requests/awaitingClaims',
    //         searchable: true,
    //         parent: 'requests'
    //     }
    // },
    // {
    //     path: 'claimed',
    //     name: 'mm-claims',
    //     component: () => import('@/views/requests/reports/ClaimsLibrary.vue'),
    //     meta: {
    //         require_auth: true,
    //         title: 'Claims',
    //         icon: 'LogOutIcon',
    //         slug: 'requests/claims',
    //         searchable: true,
    //         parent: 'requests'
    //     }
    // }
]

export default requests_routes
